/**
 * * @module components/breadcrumb.js
 */
import regeneratorRuntime from "regenerator-runtime";
import backbone from "backbone";
import $ from "jquery";
import _ from "underscore";

const Breadcrumb = Backbone.View.extend({
  el: $(document),
  events: {},

  initialize: function () {
    this.render();
  },

  reformatBreadcrumb: function(){
    if('.breadcrumb'){
      const $breadCrumb = $('.breadcrumb');
      const $lastItem = $('.item:last-child', $breadCrumb);

      $lastItem.addClass('last'); 
    }
  },

  render: function () {
    this.reformatBreadcrumb();
  },
});

export default Breadcrumb;
